export default __webpack_public_path__ + "images/f7fd242cf317d0dd0148e23c598f1b81-thrive-logo-icon.svg";